// extracted by mini-css-extract-plugin
export default {"section":"Qs-z","inSectionButton":"Rs-z","addressCard":"Ss-z","disabled":"Ts-z","cautionBox":"Us-z","failureBox":"Vs-z","fade-out":"Ws-z","successBox":"Xs-z"};